// extracted by mini-css-extract-plugin
export default {"StickyLayoutWrapper":"VbVXruNq","noSpacing":"uGWfqDwx"};